export interface NodeLayout {
  x: number;
  y: number;
}

const STORAGE_PREFIX = "automations:layout:";

/**
 * Node positions are UI-only and not part of the backend contract, so layout is
 * persisted per-browser in localStorage, keyed by workflowId.
 */
export function readLayout(workflowId: string): Record<string, NodeLayout> {
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + workflowId);
    if (!raw) return {};
    return JSON.parse(raw) as Record<string, NodeLayout>;
  } catch {
    return {};
  }
}

export function writeLayout(workflowId: string, layout: Record<string, NodeLayout>): void {
  localStorage.setItem(STORAGE_PREFIX + workflowId, JSON.stringify(layout));
}

export function clearLayout(workflowId: string): void {
  localStorage.removeItem(STORAGE_PREFIX + workflowId);
}
